<template>
  <b-container fluid>
    <page1 id="page1" />
    <AnimateWrap>
      <page2 id="page2" :numbers="main.page2" />
    </AnimateWrap>
    <AnimateWrap>
      <page3 id="page3" :numbers="main.page3" :data-desktop-mobile="dataDesktopMobile" />
    </AnimateWrap>
    <AnimateWrap>
      <page4 id="page4" :numbers="main.page4" :data-india-singapore="dataIndiaSingapore" />
    </AnimateWrap>
    <AnimateWrap>
      <page5 id="page5" :numbers="main.page5" />
    </AnimateWrap>
    <AnimateWrap>
      <page6 id="page6" :numbers="main.page6" />
    </AnimateWrap>
    <AnimateWrap>
      <page7 id="page7" :numbers="main.page7" />
    </AnimateWrap>
    <AnimateWrap>
      <page8 id="page8" :numbers="main.page8" :data-social-week="dataSocialWeek" />
    </AnimateWrap>
    <AnimateWrap>
      <page9 id="page9" :numbers="main.page9" />
    </AnimateWrap>
    <AnimateWrap>
      <page10 id="page10" />
    </AnimateWrap>
  </b-container>
</template>

<script>
import page1 from "./components/slides/page1.vue";
import page2 from "./components/slides/page2.vue";
import page3 from "./components/slides/page3.vue";
import page4 from "./components/slides/page4.vue";
import page5 from "./components/slides/page5.vue";
import page6 from "./components/slides/page6.vue";
import page7 from "./components/slides/page7.vue";
import page8 from "./components/slides/page8.vue";
import page9 from "./components/slides/page9.vue";
import page10 from "./components/slides/page10.vue";
import AnimateWrap from "./components/AnimateWrap.vue";

const myData = require("./data/main.json");
const dataDesktopMobile = require("./data/desktop-mobile.csv");
const dataIndiaSingapore = require("./data/india-singapore.csv");
const dataSocialWeek = require("./data/social-week.csv");

export default {
  name: "App",
  components: {
    AnimateWrap,
    page1,
    page2,
    page3,
    page4,
    page5,
    page6,
    page7,
    page8,
    page9,
    page10
  },
  data: () => {
    return {
      main: myData,
      dataDesktopMobile,
      dataIndiaSingapore,
      dataSocialWeek
    };
  },
  metaInfo: {
    htmlAttrs: {
      lang: 'en'
    }
  }
};
</script>

<style lang="scss"></style>
